import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import "waypoints/lib/noframework.waypoints";
import Swiper from "swiper/swiper-bundle";
import FloatSidebar from "float-sidebar";

(function ($, window) {
  const api = {};
  api.init = function () {
    $("html").removeClass("no-js");

    const waypoints = document.querySelectorAll(
      ".waypoint, .slideup"
    );

    [...waypoints].forEach(function (element, index) {
      new Waypoint({
        element,
        handler: function (direction) {
          this.element.classList.add("on-screen");
          if (this.element.dataset.title ) {
            $('.service-section-bullets-item').addClass('inactive');
            $('.service-section-bullets-item').removeClass('current');
            $('.service-section-bullets-item:lt(' + this.element.dataset.i + ')').removeClass('inactive');
            $('.service-section-bullets-item:eq(' + (this.element.dataset.i - 1) + ')').addClass('current');
            $('.service-section-bullets').addClass('active');
          }
        },
        offset: "70%",
      });
    });

    if (window.innerWidth > 991) {
      const sidebar = document.querySelector(".vertical-text-wrap");
      const relative = document.querySelector(".our-recent-work-list");

      if (sidebar && relative) { console.log(FloatSidebar, sidebar, relative);
        const floatSidebar = FloatSidebar({
          sidebar,
          relative,
          topSpacing: 120,
          bottomSpacing: 120,
        });
      }
    }


    $(".project-slider .swiper").each(function (i, elem) {
      const swiper = new Swiper(elem, {
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    });

    $(".icon-text-slider .swiper").each(function (i, elem) {
      const swiper = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
          1600: {
            slidesPerView: 2,
            spaceBetween: 320,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });

    $(".play-video").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      let video = $this.prev()[0];
      video.play();
      video.controls = true;
      $this.addClass('hide');
    });

    $(".js--load-more").each(function (i, elem) {
      $(elem).on("click", api.loadMore);
    });

    if ($('.service-section').length > 0) {
      var bullets = [];
      var bullets_html = $('<div class="service-section-bullets"></div>');
      $('body').append(bullets_html);
      $('.service-section').each(function (i, elem) {
        elem.dataset.i = i + 1;
        var bullet_html = $('<div class="service-section-bullets-item inactive"><div class="service-section-bullets-title"><span>'+elem.dataset.title+'</span></div></div>');
        bullet_html.css('background-color', elem.dataset.accentColor);
        bullets.push(bullet_html);
        bullets_html.append(bullet_html);
      });
    }

    let selectedFilters = {};

    $('.reset-filter').on('click', function (e) {
      e.preventDefault();
      selectedFilters = {};
      api.getWorks(selectedFilters);
    });
    $('.dropdown-filter a').on('click', function (e) {
      e.preventDefault();
      let selected = $(this).data('value').split(':');
      selectedFilters[selected[0]] = selected[1];
      api.getWorks(selectedFilters);
    });

  };

  api.getWorks = function (selectedFilters) {
    $('.work-list-wrap').addClass("loading");
    $.ajax({
      url: __jsVars.ajax_url,
      type: "get",
      data: {
        action: "ajax_work",
        filters: selectedFilters,
      },
      success: function (result) {
        var $html = $(result);
        $('.work-list-wrap').html($html);
        var items = $html.find(".our-recent-work-item");
        items.each(function (index, elem) {
          $(elem).css({
            "animation-delay": index * 0.1 + "s",
          });
        });
        items.addClass("fadein");
        $('.work-list-wrap').removeClass("loading");
      },
    });
  }

  api.loadMore = function (event) {
    event.preventDefault();
    event.stopPropagation();
    var $this = $(this);
    var max_num_pages = $this.data("max_num_pages");
    var cid = $this.data("cid");
    var page = parseInt($this.data("page"));

    var $content = $($this.data("target"));

    if (max_num_pages == 1) {
      $this.removeClass("loading").addClass("hide");
      return;
    }
    if (page <= max_num_pages) {
      $this.addClass("loading");
      $.ajax({
        url: __jsVars.ajax_url,
        type: "get",
        data: {
          action: "ajax_pagination",
          page: page,
          cid: cid,
        },
        success: function (result) {
          var $html = $(result);
          $content.append($html);
          var items = $html.find(".news-item");
          items.each(function (index, elem) {
            $(elem).css({
              "animation-delay": index * 0.1 + "s",
            });
          });
          items.addClass("fadein");
          $this
            .removeClass("loading")
            .toggleClass("d-none", page == max_num_pages);
          $this.data("page", page + 1);
        },
      });
    }

  };

  api.onScroll = function (e) {};
  //document ready
  $(function () {
    api.init();
  });

  // $(window).on("scroll", api.onScroll);
})(jQuery, window);
